import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

class SettingsRedirect extends Component {

  render() {
    return <Redirect to={{
      pathname: '/settings/athlete-info'
    }}/>
  }
}

export default SettingsRedirect


// WEBPACK FOOTER //
// ./src/screens/UserPortal/Settings/SettingsRedirect.js